export default __webpack_public_path__ + "static/joseph-kids-cb8c1c6ab29cc54fcca69808716b68e5.jpg";